import Lookup from '../componentes/select-async';
import ObjetivoList from 'src/paginas/okr/Objetivo/ListView';

const Objetivo = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/ObjetivoLookup"
      searchComponent={ObjetivoList}
      showSearch
      {...props}
    />
  );
};

export default Objetivo;
